import { makeBlock, setOpenHeight } from './helpers/common';
export default class Accordion {
    constructor(el, options = {}) {
        this.el = el;
        this.options = Object.assign({ content: '[data-accordion-content]', animate: true, onStart: () => { } }, options);
        this.blocks = new Map();
    }
    closeAll(options = {}) {
        this.el.querySelectorAll(this.options.content).forEach((block) => this.close(block, options));
    }
    openAll(options = {}) {
        this.el.querySelectorAll(this.options.content).forEach((block) => this.open(block, options));
    }
    open(el, options = {}) {
        this._open(el, options);
    }
    close(el, options = {}) {
        this._close(el, options);
    }
    toggle(el, options = {}) {
        const { isOpen } = this._getBlock(el);
        if (isOpen) {
            this._close(el, options);
        }
        else {
            this._open(el, options);
        }
    }
    unload() {
        this.blocks.forEach(({ animation }) => animation.unload());
    }
    _getBlock(el) {
        const block = el.matches(this.options.content) ? el : el.querySelector(this.options.content);
        if (!this.blocks.has(block)) {
            this.blocks.set(block, makeBlock(block));
        }
        return this.blocks.get(block);
    }
    _open(el, { onComplete = () => { }, force = !this.options.animate }) {
        const block = this._getBlock(el);
        if (block.isOpen)
            return;
        block.isOpen = true;
        this.options.onStart({
            el: block.animation.el,
            state: 'open',
        });
        block.animation
            .animateTo('open', {
            force,
            onStart: ({ el }) => setOpenHeight(el),
        })
            .then((state) => {
            if (state === 'open') {
                onComplete();
            }
        });
    }
    _close(el, { onComplete = () => { }, force = !this.options.animate }) {
        const block = this._getBlock(el);
        if (!block.isOpen)
            return;
        block.isOpen = false;
        this.options.onStart({
            el: block.animation.el,
            state: 'closed',
        });
        setOpenHeight(block.animation.el);
        block.animation
            .animateTo('closed', {
            force,
        })
            .then((state) => {
            if (state === 'closed') {
                onComplete();
            }
        });
    }
}
